import React from 'react';
import { User } from '../../models/User';
import Avatar from '../Avatar';
import Loader from '../Loader';

type UserListCardProps = {
  title: string;
  users?: User[] | null; 
  isLoading?: boolean; 
};

const UserListCard: React.FC<UserListCardProps> = ({ title, users, isLoading = false }) => {
  return (
    <div className="p-3 w-full min-h-40 ">
      <h2 className="text-sm">{title}</h2>
      <div className="mt-2 bg-white space-y-3 max-h-52 overflow-y-auto dark:bg-darkBg">

        {isLoading && (
          <div className="min-h-52 flex justify-center items-center">
          <Loader size='sm'/>
          </div>
        )}

        {!isLoading && users && users.length > 0 ? (
          users.map((user: User, index: number) => (
            <div key={index} className="flex items-center gap-2 p-2 hover:bg-gray-50 rounded-lg">
              <Avatar
                src={user.profileImage}
                size="xs"
                nameInitials={user.fullName || '-'}
              />
              <span className="whitespace-nowrap text-sm text-gray-700">
                {user.fullName || 'Unknown User'}
              </span>
            </div>
          ))
        ) : (
          !isLoading && (
            <div className="flex justify-center items-center h-fit">
              <p className="text-gray-500 text-sm">No user found</p>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default UserListCard;
